// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --header-height: 3rem;
  --nav-width: 68px;
  --first-color: #f10086;
  --first-color-alt: #f582a7;
  --white-color: #ffddee;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

ul {
  list-style: none;
}

main {
  position: relative;
  margin: var(--header-height) 0 0 0;
  padding: 0 1rem;
  font-size: 1rem;
  font-family: 'Nunito Sans', sans-serif;
  transition: 0.5s;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  height: var(--header-height);
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--white-color);
  padding: 0 1rem;
  transition: 0.5s;
}

.header-toggle {
  font-size: 1.25rem;
  cursor: pointer;
  color: var(--first-color);
}

.sidebar {
  position: fixed;
  top: 0;
  left: -30%;
  height: 100vh;
  width: var(--nav-width);
  background-color: var(--first-color);
  padding-top: 1rem;
  transition: 0.5s;     
}

.nav { 
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  height: 100%;
}

.nav-logo,
.nav-link {
  display: grid;
  grid-template-columns: max-content max-content;
  column-gap: 2rem;
  padding: 0.5rem 0 0.5rem 1.5rem;
}

.nav-logo {
  margin-bottom: 2rem;
}

.nav-logo-icon {
  font-size: 1.25rem;
  color: var(--white-color);
  cursor: pointer;
}

.nav-logo-name {
  font-weight: 700; 
  color: var(--white-color);
}

.nav-link {
  position: relative;
  color: var(--first-color-alt);
  transition: 0.5s;
  margin-bottom: 1.5rem;
}

.nav-link:hover {
  color: var(--white-color);
  background-color: rgba(0, 0, 0, 0.1);
}

.active {
  color: var(--white-color);
  background-color: rgba(0, 0, 0, 0.1);
}

.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 38px;
  width: 3px;
  background-color: var(--white-color);
  transition: 0.5s;
}

.show {
  left: 0;
}

.space-toggle {
  padding-left: calc(var(--nav-width) + 1rem);
}

@media screen and (min-width: 768px) {
  main {
    margin: calc(var(--header-height) + 1rem) 0 0 0;
    padding: 0 1rem 0 calc(var(--nav-width) + 2rem);
  }

  .header {
    height: calc(var(--header-height) + 1rem);
    padding-left: calc(var(--nav-width) + 2rem);
  }

  .sidebar {
    left: 0;
    padding: 1rem 0 0 0;
  }

  .show {
    width: calc(var(--header-height) + 156px);
  }

  .space-toggle {
    padding-left: calc(var(--nav-width) + 188px);
  }
}


.sidebar-content{
  margin-top: 40px !important;
}

.activeClicked{
  margin-top: 40px !important;
}

.toca-icon{
  width: 80px !important;
  margin-left: 50px !important;
  margin-top: 30px !important;
}

  .img-ykbut{
    width: 100%;
    height: 100%;
    position: fixed;
    background-position: center;
    margin-top: -0% !important;
  }

.person-profile{
  color: white !important;
}

.icon-speed{
  color: white !important;
}

.logo-sidebar{
  width: 70px;
}

.logo-pi{
  max-width: 70%;
  display: block; 
  margin: 0 auto; 
  text-align: center;
}
.responsive-img {
  width: 30%;
  padding-bottom: 8%;
  padding-top: 0%;
}

.MuiDrawer-paper {
  background-color:  #176B87 !important;
}

.text-sidebar {
  color: white !important;
}

.color-icon{
  color: white !important;
}


.text-selamat {
  margin-left: 20%; 
  font-size: 14px;
}

.selamat {
  font-size: 1.1em !important;
  color: white;
  margin-left: 0; 
}

.user {
  font-size: 1.1em;
  color: white;
  font-weight: bold;
  margin-left: 0; 
}

.img_sidebar {
  width: 20%;
  margin-left: auto;
  margin-top: -21%;
  margin-right: -3%;
  object-fit: cover; 
  aspect-ratio: 1 / 1; 

  @media only screen and (min-width: 1025px) {
    width: 12%;
    margin-left: 80%;
    margin-top: -9%;
    height: 17%;
  }

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 15%;
    margin-left: 80%;
    margin-top: -13.5%;
  }
}


.toca {
  text-align: justify;
  color: #fff;
  margin-left: 0;
}

@media only screen and (max-width: 767px) {
  .text-selamat {
    margin-left: 0; 
  }

  .selamat,
  .user,
  .toca {
    margin-left: 13%;
  }
}


@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .text-selamat {
    margin-left: 0%; 
    font-size: 20px;
  }

  .selamat,
  .user,
  .toca {
    margin-left: 13% !important; 
  }
}


@media only screen and (min-width: 1025px) {
  .text-selamat {
    margin-left: 5%; 
    font-size: 20px;
    margin-top: -5%;
    
  }

  .selamat,
  .user,
  .toca {
    margin-left: 20px !important;
  }
}

.tentang1{
  text-align: center;
  font-size: 18px !important;
  font-family: 'Poppins' !important;
  color: black;
}

.description1{
  margin-top: 2% !important;
  color: black;
  font-family: 'Poppins' !important;
  text-align: justify;
  font-size: 15px !important
}

/* .wrapper-5 {
  width: 450px;
  height: 105px;
  margin: 80px auto;
  padding: 40px 30px 30px 30px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 15%;
  position: relative;
  padding: 20px;
  overflow: auto !important;
  margin-left: 25%;
} */

/* Gaya untuk perangkat mobile */
/* @media only screen and (max-width: 767px) {
  .wrapper-5 {
    width: 93%;
    margin: 20px auto;
    margin-left: 12%;
    margin-top: 4%;
    padding: 5px;
  }
} */

/* Gaya untuk layar iPad */
/* @media only screen and (min-width: 768px) and (max-width: 1024px) {
  .wrapper-5 {
    width: 90%; 
    height: 50%;
    margin-left: 9%;
    margin-top: 3%;
    height: 50%;
  }
} */

/* Gaya untuk layar desktop */
/* @media only screen and (min-width: 1025px) {
  .wrapper-5 {
    width: 50%; 
    height: 150px;
    margin-left: 25%;
    margin-top: 1%;
  }
} */


.carousel-container {
  margin-top: 10%;
  padding: 10px;
  display: flex;
  justify-content: center;
  margin-left: 18% !important;
}

.carousel-item {
  padding: 0px;
  text-align: center;
  width: 290px !important; 
  margin: 0 auto;
}


@media only screen and (max-width: 767px) {
  .carousel-container {
    margin-top: -6% !important;
    margin-left: 15% !important;
  }

  .carousel-item {
    width: 300px !important;
    height: auto;
  }
}

@media only screen and (min-width: 768px) {
  .carousel-container {
    margin-top: -1%;
    margin-left: 35%; 
  }

  .carousel-item {
    width: 400px;
    height: auto;
  }
}


@media only screen and (min-width: 1025px) {
  .carousel-container {
    position: absolute !important;
    bottom: 0 !important;
    right: 0 !important;
    left : 35% !important;
    top: 47%;
   
  }
  .carousel{
    width: 90px !important;
    height: 10px !important;

  }
  
  .carousel-item {
    padding: 0px;
    text-align: center;
    width: 185px !important; 
    margin: 0 auto;
    margin-top: 4% !important;
  }
}


@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .carousel-container {
    margin-top: 3%;
    margin-left: 31% !important;
  }

  .carousel-item {
    width: 320px !important; 
  }
}
/* 
.btn-new-star {
  margin-top: 7%;
  background-color: #FEB800;
  color: #fff;
  border: none;
  border-radius: 42px; 
  padding: 2%;
  padding-top: 5%;
  padding-bottom: 5%;
  height: 50px;
  width: 150px;
  font-weight: bold;
  align-items: center !important;
}

.newstar {
  font-size: 30px !important;  
}

.total-star {
  margin-left: 10%;
  margin-top: 10%;
}

.total {
  color: black;
}

/* Styling untuk perangkat iPad dan perangkat dengan lebar layar 768px - 1024px */
/* @media (min-width: 768px) and (max-width: 1024px) {
  .btn-new-star {
    width: 19% !important;
    height: 25%;
    margin-left: 18%;
    margin-top: -5% !important;
  }

  .newstar {
    font-size: 30px !important;
  } */

  /* .total-star {
    font-size: 17px;
    margin-top: 2%;
    margin-left: 14%;
    font-size: 17px;
    margin-top: 2%;
    margin-left: 23%;
  } */

/* } */

/* Styling untuk perangkat mobile */
/* @media (max-width: 767px) {
  .btn-new-star {
    width: 30%;
    height: 30%;
    margin-left: 8%;
    margin-right: auto;
    margin-top: 70% !important;
    
  }

  .total-star {
    
    margin-top: 2%;
    margin-left: 13%;
    font-size: 13px;
  }
} */

/* .btn-new-entitas {
  margin-top: 7%;
  background-color: white;
  margin-left: 50% !important;
  color: #fff;
  border: none;
  border-radius: 42px; 
  padding: 2%;
  padding-top: 5%;
  padding-bottom: 5%;
  height: 45%;
  width: 27%;
  font-weight: bold;
  align-items: center !important;
} */

/* .button-new-entitas{
  margin-top: -17%;
} */

.new-entitas{
  font-size: 30px !important;  
}

.nama-entitas{
  margin-left: 10%;
  margin-top: 10%;
}

.nama-entitas-2{
  color: black;
}


@media (min-width: 768px) and (max-width: 1024px) {
  .btn-new-entitas {
    width: 15%;
    height: 25%;
    margin-left: 10%;
  }

  .new-entitas {
    font-size: 30px !important;
  }
 
  .nama-entitas {
    /* margin-top: -3%;
    margin-left: 38%;
    font-size: 17px; */
    font-size: 17px;
    margin-top: -4%;
    margin-left: 47%;
  }
}


@media (max-width: 767px) {
  .btn-new-entitas {
    width: 20%;
    height: 25%; 
    margin-left: 13%;
    border: none;
    border-radius: 42px;
  }

  .nama-entitas {
    /* margin-left: 45%; */
    /* margin-top: -5%; */
    /* font-size: 13px; */
    margin-top: -7%;
    margin-left: 45%;
    font-size: 13px;
  }
}

.btn-new-assest {
  margin-top: 7%;
  background-color: #E31B1E;
  color: #fff;
  border: none;
  border-radius: 42px; 
  padding: 2%;
  padding-top: 5%;
  padding-bottom: 5%;
  height: 45%;
  width: 27%;
  font-weight: bold;
  align-items: center !important;
}

.new-assest{
  font-size: 30px !important;  
}

@media (min-width: 768px) and (max-width: 1024px) {
  .btn-new-assest {
    width: 15%;
    height: auto;
    margin-left: 11%;
  }

  .new-assest {
    font-size: 30px !important;
  }

  .assesst-homepage {
    /* margin-top: -3%;
    margin-left: 60%;
    font-size: 17px; */
    font-size: 17px;
    margin-top: -4%;
    margin-left: 68%;
  }
}

/* Styling untuk perangkat mobile */
/* @media (max-width: 767px) {
  .btn-new-assest {
    width: 20%;
    height: 25%;
    margin-left: 10%;
    margin-top: 3%;
  } */

  /* .assesst-homepage {
    margin-left: 70%;
    margin-top: -7%;
    font-size: 13px;
    margin-top: -6.5%;
    margin-left: 70%;
    font-size: 13px;
  } */
/* } */

.wrapper-9 {
  width: 440px;
  height: 150px;
  margin: 80px auto;
  padding: 40px 30px 30px 30px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 15%;
  position: relative;
  padding: 20px;
  /* overflow: auto !important; */
  margin-left: 25%;
}


@media only screen and (max-width: 767px) {
  .wrapper-9 {
    width: 89%; 
    margin: 20px auto;
    margin-left: 14%;
    margin-top: -3%;
    padding: 1px;
    height: 191px !important;
  }
}


@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .wrapper-9 {
    width: 50%; /* Sesuaikan sesuai kebutuhan */
    height: 200px;
    margin-left: 30%;
    margin-top: -7%;
    
  }
}


@media only screen and (min-width: 1025px) {
  .wrapper-9 {
    width: 350px; 
    margin-left: 26%;
    margin-top: -5%;
    height: 190px;
  }
  .chart{
    width: 100% !important; 
    margin-top: 5% !important;
  }
}

/* @media (min-width: 1025px) {
  .btn-new-entitas,
  .btn-new-assest,
  .btn-new-star {
    width: 10%; 
    height: 100px; 
    margin-left: 16% !important; 
    border-radius: 100%;
    margin: 5px;
    padding: 10px;
    margin-top: 5%; 
  }
  .total{
    display: flex;
    justify-items: center;
    align-items: center;
    margin-top: -10%;
  }

  .new-entitas {
    font-size: 50px !important;
    margin-top: 0%;
  }

  .nama-entitas {
    font-size: 17px;
    margin-left: 23%;
  }
  
  .newstar {
    font-size: 50px !important;
    margin-top: 0%;
  }

  .total-star {
    font-size: 17px;
    margin-left: 19.5%;
  }

  .new-assest {
    font-size: 50px !important;
    margin-top: 0%;
  }

  .assesst-homepage {
    font-size: 17px;
    margin-left: 20% ;
  }
  
} */

@media only screen and (max-width: 600px) {
  .custom-swal-container {
    width: auto !important;
    max-width: 100% !important;
    padding: 0 15px !important;
  }
  .custom-swal-popup {
    margin: 0 !important;
  }
  .custom-swal-title,
  .custom-swal-content,
  .custom-swal-confirm-button,
  .custom-swal-cancel-button {
    width: 100% !important;
    margin: 10px 0 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SideBar/SideBar.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,+CAA+C;IAC/C,+CAA+C;EACjD;;EAEA;IACE,yCAAyC;IACzC,2CAA2C;EAC7C;;EAEA;IACE,OAAO;IACP,mBAAmB;EACrB;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,4CAA4C;EAC9C;AACF;;;AAGA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;;EAEE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,0BAA0B;EAC5B;;AAEF;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;;EAEnB;IACE,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;;AAGA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;;;IAGE,gBAAgB;EAClB;AACF;;;AAGA;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;;;IAGE,2BAA2B;EAC7B;AACF;;;AAGA;EACE;IACE,eAAe;IACf,eAAe;IACf,eAAe;;EAEjB;;EAEA;;;IAGE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;EACnB;AACF;;AAEA;;;;;;;;;;;;;GAaG;;AAEH,gCAAgC;AAChC;;;;;;;;GAQG;;AAEH,0BAA0B;AAC1B;;;;;;;;GAQG;;AAEH,6BAA6B;AAC7B;;;;;;;GAOG;;;AAGH;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;;;AAGA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;AACF;;;AAGA;EACE;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,QAAQ;;EAEV;EACA;IACE,sBAAsB;IACtB,uBAAuB;;EAEzB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,yBAAyB;EAC3B;AACF;;;AAGA;EACE;IACE,cAAc;IACd,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;iFA6BiF;AACjF;;;;;;;;;;KAUK;;EAEH;;;;;;;KAOG;;AAEL,MAAM;;AAEN,mCAAmC;AACnC;;;;;;;;;;;;;;;;GAgBG;;AAEH;;;;;;;;;;;;;;GAcG;;AAEH;;GAEG;;AAEH;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE;;sBAEkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;AACF;;;AAGA;EACE;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE;;sBAEkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,mCAAmC;AACnC;;;;;;KAMK;;EAEH;;;;;;;KAOG;AACL,MAAM;;AAEN;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;;;AAGA;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,wBAAwB;EAC1B;AACF;;;AAGA;EACE;IACE,UAAU,EAAE,+BAA+B;IAC3C,aAAa;IACb,gBAAgB;IAChB,eAAe;;EAEjB;AACF;;;AAGA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiDG;;AAEH;EACE;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;EAC5B;EACA;IACE,oBAAoB;EACtB;EACA;;;;IAIE,sBAAsB;IACtB,yBAAyB;EAC3B;AACF","sourcesContent":[":root {\n  --header-height: 3rem;\n  --nav-width: 68px;\n  --first-color: #f10086;\n  --first-color-alt: #f582a7;\n  --white-color: #ffddee;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\na {\n  text-decoration: none;\n}\n\nul {\n  list-style: none;\n}\n\nmain {\n  position: relative;\n  margin: var(--header-height) 0 0 0;\n  padding: 0 1rem;\n  font-size: 1rem;\n  font-family: 'Nunito Sans', sans-serif;\n  transition: 0.5s;\n}\n\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: var(--header-height);\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--white-color);\n  padding: 0 1rem;\n  transition: 0.5s;\n}\n\n.header-toggle {\n  font-size: 1.25rem;\n  cursor: pointer;\n  color: var(--first-color);\n}\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: -30%;\n  height: 100vh;\n  width: var(--nav-width);\n  background-color: var(--first-color);\n  padding-top: 1rem;\n  transition: 0.5s;     \n}\n\n.nav { \n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  height: 100%;\n}\n\n.nav-logo,\n.nav-link {\n  display: grid;\n  grid-template-columns: max-content max-content;\n  column-gap: 2rem;\n  padding: 0.5rem 0 0.5rem 1.5rem;\n}\n\n.nav-logo {\n  margin-bottom: 2rem;\n}\n\n.nav-logo-icon {\n  font-size: 1.25rem;\n  color: var(--white-color);\n  cursor: pointer;\n}\n\n.nav-logo-name {\n  font-weight: 700; \n  color: var(--white-color);\n}\n\n.nav-link {\n  position: relative;\n  color: var(--first-color-alt);\n  transition: 0.5s;\n  margin-bottom: 1.5rem;\n}\n\n.nav-link:hover {\n  color: var(--white-color);\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.active {\n  color: var(--white-color);\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.active::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 38px;\n  width: 3px;\n  background-color: var(--white-color);\n  transition: 0.5s;\n}\n\n.show {\n  left: 0;\n}\n\n.space-toggle {\n  padding-left: calc(var(--nav-width) + 1rem);\n}\n\n@media screen and (min-width: 768px) {\n  main {\n    margin: calc(var(--header-height) + 1rem) 0 0 0;\n    padding: 0 1rem 0 calc(var(--nav-width) + 2rem);\n  }\n\n  .header {\n    height: calc(var(--header-height) + 1rem);\n    padding-left: calc(var(--nav-width) + 2rem);\n  }\n\n  .sidebar {\n    left: 0;\n    padding: 1rem 0 0 0;\n  }\n\n  .show {\n    width: calc(var(--header-height) + 156px);\n  }\n\n  .space-toggle {\n    padding-left: calc(var(--nav-width) + 188px);\n  }\n}\n\n\n.sidebar-content{\n  margin-top: 40px !important;\n}\n\n.activeClicked{\n  margin-top: 40px !important;\n}\n\n.toca-icon{\n  width: 80px !important;\n  margin-left: 50px !important;\n  margin-top: 30px !important;\n}\n\n  .img-ykbut{\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    background-position: center;\n    margin-top: -0% !important;\n  }\n\n.person-profile{\n  color: white !important;\n}\n\n.icon-speed{\n  color: white !important;\n}\n\n.logo-sidebar{\n  width: 70px;\n}\n\n.logo-pi{\n  max-width: 70%;\n  display: block; \n  margin: 0 auto; \n  text-align: center;\n}\n.responsive-img {\n  width: 30%;\n  padding-bottom: 8%;\n  padding-top: 0%;\n}\n\n.MuiDrawer-paper {\n  background-color:  #176B87 !important;\n}\n\n.text-sidebar {\n  color: white !important;\n}\n\n.color-icon{\n  color: white !important;\n}\n\n\n.text-selamat {\n  margin-left: 20%; \n  font-size: 14px;\n}\n\n.selamat {\n  font-size: 1.1em !important;\n  color: white;\n  margin-left: 0; \n}\n\n.user {\n  font-size: 1.1em;\n  color: white;\n  font-weight: bold;\n  margin-left: 0; \n}\n\n.img_sidebar {\n  width: 20%;\n  margin-left: auto;\n  margin-top: -21%;\n  margin-right: -3%;\n  object-fit: cover; \n  aspect-ratio: 1 / 1; \n\n  @media only screen and (min-width: 1025px) {\n    width: 12%;\n    margin-left: 80%;\n    margin-top: -9%;\n    height: 17%;\n  }\n\n  @media only screen and (min-width: 768px) and (max-width: 1024px) {\n    width: 15%;\n    margin-left: 80%;\n    margin-top: -13.5%;\n  }\n}\n\n\n.toca {\n  text-align: justify;\n  color: #fff;\n  margin-left: 0;\n}\n\n@media only screen and (max-width: 767px) {\n  .text-selamat {\n    margin-left: 0; \n  }\n\n  .selamat,\n  .user,\n  .toca {\n    margin-left: 13%;\n  }\n}\n\n\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .text-selamat {\n    margin-left: 0%; \n    font-size: 20px;\n  }\n\n  .selamat,\n  .user,\n  .toca {\n    margin-left: 13% !important; \n  }\n}\n\n\n@media only screen and (min-width: 1025px) {\n  .text-selamat {\n    margin-left: 5%; \n    font-size: 20px;\n    margin-top: -5%;\n    \n  }\n\n  .selamat,\n  .user,\n  .toca {\n    margin-left: 20px !important;\n  }\n}\n\n.tentang1{\n  text-align: center;\n  font-size: 18px !important;\n  font-family: 'Poppins' !important;\n  color: black;\n}\n\n.description1{\n  margin-top: 2% !important;\n  color: black;\n  font-family: 'Poppins' !important;\n  text-align: justify;\n  font-size: 15px !important\n}\n\n/* .wrapper-5 {\n  width: 450px;\n  height: 105px;\n  margin: 80px auto;\n  padding: 40px 30px 30px 30px;\n  background-color: #fff;\n  border-radius: 15px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-top: 15%;\n  position: relative;\n  padding: 20px;\n  overflow: auto !important;\n  margin-left: 25%;\n} */\n\n/* Gaya untuk perangkat mobile */\n/* @media only screen and (max-width: 767px) {\n  .wrapper-5 {\n    width: 93%;\n    margin: 20px auto;\n    margin-left: 12%;\n    margin-top: 4%;\n    padding: 5px;\n  }\n} */\n\n/* Gaya untuk layar iPad */\n/* @media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .wrapper-5 {\n    width: 90%; \n    height: 50%;\n    margin-left: 9%;\n    margin-top: 3%;\n    height: 50%;\n  }\n} */\n\n/* Gaya untuk layar desktop */\n/* @media only screen and (min-width: 1025px) {\n  .wrapper-5 {\n    width: 50%; \n    height: 150px;\n    margin-left: 25%;\n    margin-top: 1%;\n  }\n} */\n\n\n.carousel-container {\n  margin-top: 10%;\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  margin-left: 18% !important;\n}\n\n.carousel-item {\n  padding: 0px;\n  text-align: center;\n  width: 290px !important; \n  margin: 0 auto;\n}\n\n\n@media only screen and (max-width: 767px) {\n  .carousel-container {\n    margin-top: -6% !important;\n    margin-left: 15% !important;\n  }\n\n  .carousel-item {\n    width: 300px !important;\n    height: auto;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .carousel-container {\n    margin-top: -1%;\n    margin-left: 35%; \n  }\n\n  .carousel-item {\n    width: 400px;\n    height: auto;\n  }\n}\n\n\n@media only screen and (min-width: 1025px) {\n  .carousel-container {\n    position: absolute !important;\n    bottom: 0 !important;\n    right: 0 !important;\n    left : 35% !important;\n    top: 47%;\n   \n  }\n  .carousel{\n    width: 90px !important;\n    height: 10px !important;\n\n  }\n  \n  .carousel-item {\n    padding: 0px;\n    text-align: center;\n    width: 185px !important; \n    margin: 0 auto;\n    margin-top: 4% !important;\n  }\n}\n\n\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .carousel-container {\n    margin-top: 3%;\n    margin-left: 31% !important;\n  }\n\n  .carousel-item {\n    width: 320px !important; \n  }\n}\n/* \n.btn-new-star {\n  margin-top: 7%;\n  background-color: #FEB800;\n  color: #fff;\n  border: none;\n  border-radius: 42px; \n  padding: 2%;\n  padding-top: 5%;\n  padding-bottom: 5%;\n  height: 50px;\n  width: 150px;\n  font-weight: bold;\n  align-items: center !important;\n}\n\n.newstar {\n  font-size: 30px !important;  \n}\n\n.total-star {\n  margin-left: 10%;\n  margin-top: 10%;\n}\n\n.total {\n  color: black;\n}\n\n/* Styling untuk perangkat iPad dan perangkat dengan lebar layar 768px - 1024px */\n/* @media (min-width: 768px) and (max-width: 1024px) {\n  .btn-new-star {\n    width: 19% !important;\n    height: 25%;\n    margin-left: 18%;\n    margin-top: -5% !important;\n  }\n\n  .newstar {\n    font-size: 30px !important;\n  } */\n\n  /* .total-star {\n    font-size: 17px;\n    margin-top: 2%;\n    margin-left: 14%;\n    font-size: 17px;\n    margin-top: 2%;\n    margin-left: 23%;\n  } */\n\n/* } */\n\n/* Styling untuk perangkat mobile */\n/* @media (max-width: 767px) {\n  .btn-new-star {\n    width: 30%;\n    height: 30%;\n    margin-left: 8%;\n    margin-right: auto;\n    margin-top: 70% !important;\n    \n  }\n\n  .total-star {\n    \n    margin-top: 2%;\n    margin-left: 13%;\n    font-size: 13px;\n  }\n} */\n\n/* .btn-new-entitas {\n  margin-top: 7%;\n  background-color: white;\n  margin-left: 50% !important;\n  color: #fff;\n  border: none;\n  border-radius: 42px; \n  padding: 2%;\n  padding-top: 5%;\n  padding-bottom: 5%;\n  height: 45%;\n  width: 27%;\n  font-weight: bold;\n  align-items: center !important;\n} */\n\n/* .button-new-entitas{\n  margin-top: -17%;\n} */\n\n.new-entitas{\n  font-size: 30px !important;  \n}\n\n.nama-entitas{\n  margin-left: 10%;\n  margin-top: 10%;\n}\n\n.nama-entitas-2{\n  color: black;\n}\n\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .btn-new-entitas {\n    width: 15%;\n    height: 25%;\n    margin-left: 10%;\n  }\n\n  .new-entitas {\n    font-size: 30px !important;\n  }\n \n  .nama-entitas {\n    /* margin-top: -3%;\n    margin-left: 38%;\n    font-size: 17px; */\n    font-size: 17px;\n    margin-top: -4%;\n    margin-left: 47%;\n  }\n}\n\n\n@media (max-width: 767px) {\n  .btn-new-entitas {\n    width: 20%;\n    height: 25%; \n    margin-left: 13%;\n    border: none;\n    border-radius: 42px;\n  }\n\n  .nama-entitas {\n    /* margin-left: 45%; */\n    /* margin-top: -5%; */\n    /* font-size: 13px; */\n    margin-top: -7%;\n    margin-left: 45%;\n    font-size: 13px;\n  }\n}\n\n.btn-new-assest {\n  margin-top: 7%;\n  background-color: #E31B1E;\n  color: #fff;\n  border: none;\n  border-radius: 42px; \n  padding: 2%;\n  padding-top: 5%;\n  padding-bottom: 5%;\n  height: 45%;\n  width: 27%;\n  font-weight: bold;\n  align-items: center !important;\n}\n\n.new-assest{\n  font-size: 30px !important;  \n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .btn-new-assest {\n    width: 15%;\n    height: auto;\n    margin-left: 11%;\n  }\n\n  .new-assest {\n    font-size: 30px !important;\n  }\n\n  .assesst-homepage {\n    /* margin-top: -3%;\n    margin-left: 60%;\n    font-size: 17px; */\n    font-size: 17px;\n    margin-top: -4%;\n    margin-left: 68%;\n  }\n}\n\n/* Styling untuk perangkat mobile */\n/* @media (max-width: 767px) {\n  .btn-new-assest {\n    width: 20%;\n    height: 25%;\n    margin-left: 10%;\n    margin-top: 3%;\n  } */\n\n  /* .assesst-homepage {\n    margin-left: 70%;\n    margin-top: -7%;\n    font-size: 13px;\n    margin-top: -6.5%;\n    margin-left: 70%;\n    font-size: 13px;\n  } */\n/* } */\n\n.wrapper-9 {\n  width: 440px;\n  height: 150px;\n  margin: 80px auto;\n  padding: 40px 30px 30px 30px;\n  background-color: #fff;\n  border-radius: 15px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-top: 15%;\n  position: relative;\n  padding: 20px;\n  /* overflow: auto !important; */\n  margin-left: 25%;\n}\n\n\n@media only screen and (max-width: 767px) {\n  .wrapper-9 {\n    width: 89%; \n    margin: 20px auto;\n    margin-left: 14%;\n    margin-top: -3%;\n    padding: 1px;\n    height: 191px !important;\n  }\n}\n\n\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .wrapper-9 {\n    width: 50%; /* Sesuaikan sesuai kebutuhan */\n    height: 200px;\n    margin-left: 30%;\n    margin-top: -7%;\n    \n  }\n}\n\n\n@media only screen and (min-width: 1025px) {\n  .wrapper-9 {\n    width: 350px; \n    margin-left: 26%;\n    margin-top: -5%;\n    height: 190px;\n  }\n  .chart{\n    width: 100% !important; \n    margin-top: 5% !important;\n  }\n}\n\n/* @media (min-width: 1025px) {\n  .btn-new-entitas,\n  .btn-new-assest,\n  .btn-new-star {\n    width: 10%; \n    height: 100px; \n    margin-left: 16% !important; \n    border-radius: 100%;\n    margin: 5px;\n    padding: 10px;\n    margin-top: 5%; \n  }\n  .total{\n    display: flex;\n    justify-items: center;\n    align-items: center;\n    margin-top: -10%;\n  }\n\n  .new-entitas {\n    font-size: 50px !important;\n    margin-top: 0%;\n  }\n\n  .nama-entitas {\n    font-size: 17px;\n    margin-left: 23%;\n  }\n  \n  .newstar {\n    font-size: 50px !important;\n    margin-top: 0%;\n  }\n\n  .total-star {\n    font-size: 17px;\n    margin-left: 19.5%;\n  }\n\n  .new-assest {\n    font-size: 50px !important;\n    margin-top: 0%;\n  }\n\n  .assesst-homepage {\n    font-size: 17px;\n    margin-left: 20% ;\n  }\n  \n} */\n\n@media only screen and (max-width: 600px) {\n  .custom-swal-container {\n    width: auto !important;\n    max-width: 100% !important;\n    padding: 0 15px !important;\n  }\n  .custom-swal-popup {\n    margin: 0 !important;\n  }\n  .custom-swal-title,\n  .custom-swal-content,\n  .custom-swal-confirm-button,\n  .custom-swal-cancel-button {\n    width: 100% !important;\n    margin: 10px 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
